// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f4f4f9;
  }
  
  .login-card {
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 20px;
    width: 300px;
    text-align: center;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background-color: #fff;
  }
  
  .login-card input {
    width: 90%;
    padding: 10px;
    margin: 10px 0;
    border: 1px solid #ddd;
    border-radius: 5px;
  }
  
  .login-card button {
    width: 100%;
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .login-card button:hover {
    background-color: #0056b3;
  }

  .login-card .buttonVazgec{
    width: 100%;
    padding: 10px;
    background-color: #ec1b1b;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  .login-card .buttonVazgec:hover {
    background-color: #841f09;
  }
  

.image-list-container {
  display: flex;
  align-items: center;
  height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  flex-direction: column;
  }

  
  .image-list-container h2 {
    margin-bottom: 20px;
    
  }`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yDAAoD;EACpD,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;EACtB;;;EAGA;IACE,mBAAmB;;EAErB","sourcesContent":[".login-page {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    background-color: #f4f4f9;\n  }\n  \n  .login-card {\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    padding: 20px;\n    width: 300px;\n    text-align: center;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    background-color: #fff;\n  }\n  \n  .login-card input {\n    width: 90%;\n    padding: 10px;\n    margin: 10px 0;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n  }\n  \n  .login-card button {\n    width: 100%;\n    padding: 10px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  \n  .login-card button:hover {\n    background-color: #0056b3;\n  }\n\n  .login-card .buttonVazgec{\n    width: 100%;\n    padding: 10px;\n    background-color: #ec1b1b;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n\n  .login-card .buttonVazgec:hover {\n    background-color: #841f09;\n  }\n  \n\n.image-list-container {\n  display: flex;\n  align-items: center;\n  height: 100vh;\n  background-image: url('../../assets/background.jpg');\n  background-size: cover;\n  background-position: center;\n  flex-direction: column;\n  }\n\n  \n  .image-list-container h2 {\n    margin-bottom: 20px;\n    \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
